module.exports = "<p>\n  support works!\n</p>\n"